import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuthUser } from '../../context/AuthUserContext';
import './Carrito.css';
import { generarReciboCarrito } from './reciboCarrito';

/* ── Icons ── */
const IconCart     = () => (<svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconTrash    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconPdf      = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconKit      = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="7" width="20" height="15" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconGame     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="6" width="20" height="12" rx="4" stroke="currentColor" strokeWidth="2"/><path d="M7 12h4M9 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="16" cy="12" r="1.5" fill="currentColor"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconArrow    = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconLock     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'cart-spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconShield   = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconDigital  = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M8 21h8M12 17v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTag      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="7" y1="7" x2="7.01" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);

const LogoComunicar = ({ height = 40 }) => (
  <img 
    src="/images/logo_centro.png" 
    alt="Comunicar" 
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

const colorMap = {
  verde:    { bg:'linear-gradient(135deg,#d4f4e8,#82D8B3)', text:'#0f3525' },
  azul:     { bg:'linear-gradient(135deg,#dbeafe,#60a5fa)', text:'#1e3a5f' },
  amarillo: { bg:'linear-gradient(135deg,#fef9c3,#fbbf24)', text:'#713f12' },
  rosa:     { bg:'linear-gradient(135deg,#fce7f3,#f9a8d4)', text:'#831843' },
  morado:   { bg:'linear-gradient(135deg,#ede9fe,#a78bfa)', text:'#3b0764' },
  gris:     { bg:'linear-gradient(135deg,#f3f8f5,#82D8B3)', text:'#0f3525' },
};
const tipoIcono = { recurso: IconPdf, kit: IconKit, juego: IconGame };
const tipoLabel = { recurso:'PDF', kit:'Kit', juego:'Juego' };

const API_PAGA   = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';
const API_CUPONES    = 'https://centrocomunicar.com/api-comunicar/endpoints/cupones.php';
const API_INSCRIPCION= 'https://centrocomunicar.com/api-comunicar/endpoints/moodle_inscripcion.php';

export default function Carrito() {
  const { items, quitarItem, vaciarCarrito, totalItems, totalPrecio } = useCart();
  const { estaLogueado, usuario } = useAuthUser();
  const navigate = useNavigate();

  const [metodo,     setMetodo]     = useState(null);
  const [culqiListo, setCulqiListo] = useState(false);

  const [form, setForm] = useState({
    nombre:   usuario ? [usuario.nombre, usuario.apellido].filter(Boolean).join(' ').toUpperCase() : '',
    email:    usuario?.email    || '',
    telefono: usuario?.whatsapp || usuario?.telefono || '',
  });

  const [procesando, setProcesando] = useState(false);
  const [error,      setError]      = useState('');
  const [pedido,     setPedido]     = useState(null);
  const [estadoPago, setEstadoPago] = useState('pendiente'); // pendiente|voucher_enviado|validado
  const pollingRef = useRef(null);

  /* ── Estado cupón ── */
  const [codigoCupon,   setCodigoCupon]   = useState('');
  const [validandoCupon,setValidandoCupon]= useState(false);
  const [cuponAplicado, setCuponAplicado] = useState(null);  // objeto del cupón válido
  const [cuponError,    setCuponError]    = useState('');
  const [cuponExito,    setCuponExito]    = useState('');

  function setF(k, v) { setForm(p => ({ ...p, [k]: v })); }

 // Cargar Culqi JS
 useEffect(() => {
  if (document.getElementById('culqi-script')) { setCulqiListo(true); return; }
  const script = document.createElement('script');
  script.id  = 'culqi-script';
  script.src = 'https://checkout.culqi.com/js/v4';
  script.onload = () => setCulqiListo(true);
  document.body.appendChild(script);
}, []);

  /* ── Validar cupón ── */
  const validarCupon = useCallback(async () => {
    if (!codigoCupon.trim()) return;
    setCuponError(''); setCuponExito(''); setValidandoCupon(true);
    try {
      const params = new URLSearchParams({
        action:       'validar',
        codigo:       codigoCupon.trim().toUpperCase(),
        monto:        totalPrecio,
        // carrito = sin producto específico, aplica si es 'todos','recursos','cursos'
      });
      const r = await fetch(`${API_CUPONES}?${params}`);
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setCuponAplicado(j.data);
      setCuponExito(`¡Cupón aplicado! Ahorras S/. ${j.data.descuento.toFixed(2)}`);
      setCodigoCupon('');
    } catch(e) {
      setCuponError(e.message);
      setCuponAplicado(null);
    } finally { setValidandoCupon(false); }
  }, [codigoCupon, totalPrecio]);

  function quitarCupon() {
    setCuponAplicado(null);
    setCuponError('');
    setCuponExito('');
    setCodigoCupon('');
  }

  /* Total con descuento */
  const descuento   = cuponAplicado ? cuponAplicado.descuento : 0;
  const totalFinal  = Math.max(0, totalPrecio - descuento);

  /* ── Polling: verificar estado del pedido cada 8 segundos ── */
  useEffect(() => {
    console.log('POLLING pedido:', pedido?.id, 'token:', pedido?.token_inscripcion, 'estado:', estadoPago);
    if (!pedido?.id || !pedido?.token_inscripcion) return;
    if (estadoPago === 'validado') return;

    pollingRef.current = setInterval(async () => {



      try {
        const r = await fetch(
          `${API_INSCRIPCION}?action=verificar_estado&pedido_id=${pedido.id}&token=${pedido.token_inscripcion}`
        );
        const j = await r.json();
        if (j.success && j.data?.estado === 'validado') {
          setEstadoPago('validado');
          clearInterval(pollingRef.current);
        }
      } catch {}
    }, 8000);

    return () => clearInterval(pollingRef.current);
  }, [pedido, estadoPago]);

  /* ── Crear pedido en backend ── */
  async function crearPedido(metodoPago) {
    setError('');
    if (!form.nombre.trim())       { setError('Ingresa tu nombre'); return null; }
    if (!form.email.includes('@')) { setError('Email no válido'); return null; }
    setProcesando(true);
    try {
      const token = localStorage.getItem('com_token');
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const res = await fetch(`${API_PAGA}?action=crear_pedido_carrito`, {
        method: 'POST', headers,
        body: JSON.stringify({
          nombre:   form.nombre.trim(),
          email:    form.email.toLowerCase().trim(),
          telefono: form.telefono.trim(),
          items:    items.map(i => ({ id: i.id, titulo: i.titulo, precio: i.precio })),
          total:    totalFinal,
          metodo:   metodoPago,
          // Cupón
          cupon_id:        cuponAplicado?.id       || null,
          cupon_codigo:    cuponAplicado?.codigo    || null,
          descuento_cupon: descuento,
        }),
      });
      const text = await res.text();
      let json;
      try {
        json = JSON.parse(text);
      } catch {
        console.error('Respuesta del servidor:', text);
        throw new Error('Error del servidor. Revisa la consola para más detalles.');
      }
      if (!json.success) throw new Error(json.message || 'Error al crear pedido');
      // Registrar uso del cupón si aplica
      if (cuponAplicado && json.data?.id) {
        const usrToken = localStorage.getItem('com_token');
        const hd = { 'Content-Type': 'application/json' };
        if (usrToken) hd['Authorization'] = `Bearer ${usrToken}`;
        await fetch(`${API_CUPONES}?action=aplicar`, {
          method:'POST', headers: hd,
          body: JSON.stringify({
            cupon_id:    cuponAplicado.id,
            pedido_id:   json.data.id,
            email:       form.email.toLowerCase().trim(),
            monto_orig:  totalPrecio,
            descuento:   descuento,
            monto_final: totalFinal,
          }),
        });
      }

      // Guardar token de inscripción junto al pedido
      if (json.data?.id && json.data?.link_inscripcion) {
        try {
          const urlObj = new URL(json.data.link_inscripcion);
          json.data.token_inscripcion = urlObj.searchParams.get('token') || null;
        } catch {
          const m = json.data.link_inscripcion.match(/[?&]token=([^&]+)/);
          json.data.token_inscripcion = m ? m[1] : null;
        }
      }
      return json.data;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setProcesando(false);
    }
  }

  /* ── Pagar con Izipay ── */
  async function pagarTarjeta() {
    if (!estaLogueado) { navigate('/login?redirect=/carrito'); return; }
    const data = await crearPedido('tarjeta');
    if (!data) return;
    setProcesando(true);
    try {
      const token = localStorage.getItem('com_token');
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const res = await fetch('https://centrocomunicar.com/api-comunicar/endpoints/izipay_redirect.php', {
        method: 'POST', headers,
        body: JSON.stringify({
          pedido_carrito_id: data.id,
          pedido_codigo:     data.codigo,
          monto:             totalFinal,
          email:             form.email.toLowerCase().trim(),
          nombre:            form.nombre.trim(),
        }),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.message);
      const form_el = document.createElement('form');
      form_el.action = json.url; form_el.method = 'POST';
      Object.entries(json.params).forEach(([key, val]) => {
        const inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = key; inp.value = val;
        form_el.appendChild(inp);
      });
      document.body.appendChild(form_el);
      generarReciboCarrito({ pedido: data, items, form, metodo: 'tarjeta', descuento, cuponAplicado, totalFinal });
form_el.submit();
    } catch (err) {
      setError(err.message);
    } finally {
      setProcesando(false);
    }
  }

  /* ── Pagar con Culqi ── */
  function pagarCulqi() {
    if (!estaLogueado) { navigate('/login?redirect=/carrito'); return; }
    if (!form.nombre.trim()) { setError('Ingresa tu nombre'); return; }
    if (!form.email.includes('@')) { setError('Email no válido'); return; }
    if (!culqiListo || !window.Culqi) { setError('Culqi no está listo, recarga la página'); return; }

    window.Culqi.publicKey = 'pk_live_q8uWthWANueTtfxM';
    window.Culqi.settings({
      title:       'Comunicar',
      currency:    'PEN',
      description: items.map(i => i.titulo).join(', ').slice(0, 80),
      amount:      Math.round(totalFinal * 100),
    });
    window.Culqi.options({ lang: 'es', installments: false });

    window.culqi = async () => {
      if (window.Culqi.token) {
        const culqiToken = window.Culqi.token.id;
        window.Culqi.close();
        setProcesando(true);
        setError('');
        try {
          // Crear pedido primero
          const data = await crearPedido('culqi');
          if (!data) return;

          // Luego hacer cargo con Culqi
          const authToken = localStorage.getItem('com_token');
          const headers   = { 'Content-Type': 'application/json' };
          if (authToken) headers['Authorization'] = `Bearer ${authToken}`;

          const res = await fetch(
            'https://centrocomunicar.com/api-comunicar/endpoints/culqi_charge.php?action=crear_cargo',
            {
              method: 'POST', headers,
              body: JSON.stringify({
                culqi_token:      culqiToken,
                pedido_carrito_id: data.id,
                monto:            totalFinal,
                email:            form.email.toLowerCase().trim(),
                nombre:           form.nombre.trim(),
              }),
            }
          );
          const json = await res.json();
          if (!json.success) throw new Error(json.message);

          // Éxito — vaciar carrito e ir a página de éxito
          generarReciboCarrito({ pedido: data, items, form, metodo: 'culqi', descuento, cuponAplicado, totalFinal });

          vaciarCarrito();
          navigate('/pago-exitoso?metodo=culqi&pedido=' + data.codigo);
        } catch (err) {
          setError(err.message);
        } finally {
          setProcesando(false);
        }
      } else if (window.Culqi.error) {
        setError(window.Culqi.error.user_message || 'Error en el pago');
      }
    };

    window.Culqi.open();
  }

  /* ── Pagar con Yape ── */
  async function pagarYape() {
    if (!estaLogueado) { navigate('/login?redirect=/carrito'); return; }
    const data = await crearPedido('yape');
    if (!data) return;
    setPedido(data);
generarReciboCarrito({ pedido: data, items, form, metodo: 'yape', descuento, cuponAplicado, totalFinal });
  }

  /* ── Carrito vacío ── */
  if (totalItems === 0 && !pedido) {
    return (
      <div className="cart-page">
        <nav className="cart-nav">
          <Link to="/" className="cart-nav__logo"><LogoComunicar height={40}/></Link>
          <Link to="/recursos" className="cart-nav__back">← Seguir comprando</Link>
        </nav>
        <div className="cart-empty">
          <div className="cart-empty__icon"><IconCart/></div>
          <h2>Tu carrito está vacío</h2>
          <p>Agrega materiales terapéuticos desde nuestra tienda.</p>
          <Link to="/recursos" className="cart-empty__btn">Ver materiales <IconArrow/></Link>
        </div>
      </div>
    );
  }

  /* ── Detectar si el carrito tiene cursos ── */
  const tieneCursos = items.some(i => i.tipo === 'curso' || String(i.id).startsWith('curso-'));
  const linkInscripcion = pedido?.link_inscripcion || null;

  /* ── Pedido confirmado Yape ── */
  if (pedido) {
    return (
      <div className="cart-page">
        <nav className="cart-nav">
          <Link to="/" className="cart-nav__logo"><LogoComunicar height={40}/></Link>
        </nav>
        <div className="cart-exito">
          <div className="cart-exito__icon"><IconWhatsapp/></div>
          <h2>¡Pedido registrado!</h2>
          <p>Código de pedido: <strong>{pedido.codigo}</strong></p>
          <p className="cart-exito__sub">
            Abre WhatsApp para enviarnos tu voucher de pago. Activaremos tu acceso en minutos.
          </p>
          <div className="cart-exito__items">
            {items.map(i => (
              <div key={i.id} className="cart-exito__item"><IconCheck/> {i.titulo}</div>
            ))}
          </div>
          {descuento > 0 && (
            <div className="cart-exito__cupon">
              🎉 Cupón <strong>{cuponAplicado.codigo}</strong> aplicado — ahorraste S/. {descuento.toFixed(2)}
            </div>
          )}
          <div className="cart-exito__total">
            Total pagado: <strong>S/. {totalFinal.toFixed(2)}</strong>
          </div>

          {/* Botón principal WhatsApp */}
          <a href={pedido.wa_url} target="_blank" rel="noopener noreferrer"
            className="cart-exito__wa-btn" onClick={() => vaciarCarrito()}>
            <IconWhatsapp/> Enviar voucher por WhatsApp
          </a>

          {/* Bloque inscripción curso — solo si hay cursos */}
          {tieneCursos && linkInscripcion && (
            <div className="cart-exito__inscripcion">
              <div className="cart-exito__inscripcion-head">
                <span>🎓</span>
                <div>
                  <strong>Inscripción al curso</strong>
                  <p>
                    {estadoPago === 'validado'
                      ? '¡Tu pago fue validado! Ya puedes inscribirte'
                      : 'Podrás completarla una vez que validemos tu pago'}
                  </p>
                </div>
                {estadoPago !== 'validado' && (
                  <div className="cart-exito__polling-dot" title="Verificando estado…"/>
                )}
              </div>
              <div className="cart-exito__inscripcion-estado">
                {estadoPago === 'validado' ? (
                  <span className="cart-exito__badge-validado">✓ Pago validado — listo para inscribirse</span>
                ) : (
                  <span className="cart-exito__badge-espera">⏳ Esperando validación de pago</span>
                )}
              </div>
              <div className="cart-exito__inscripcion-link">
                <span>🔗 Tu link de inscripción:</span>
                {estadoPago === 'validado' ? (
                  <a
                    href={linkInscripcion}
                    className="cart-exito__link-activo"
                    onClick={() => vaciarCarrito()}
                  >
                    <span>Completar inscripción al curso</span>
                    <span className="cart-exito__link-go">→</span>
                  </a>
                ) : (
                  <button
                    className="cart-exito__link-preview"
                    onClick={() => alert('⏳ Tu pago aún está siendo validado.\n\nEsta página se actualiza automáticamente.\n\nGeneralmente en menos de 24 horas.')}
                  >
                    <span>centrocomunicar.com/registro-curso</span>
                    <span className="cart-exito__link-lock">🔒 Pendiente</span>
                  </button>
                )}
                {estadoPago !== 'validado' && (
                  <p className="cart-exito__link-nota">
                    📧 También te enviaremos este link por email cuando validemos tu pago
                  </p>
                )}
              </div>
            </div>
          )}

          <button className="cart-exito__link" onClick={() => { vaciarCarrito(); navigate('/'); }}>
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">

      {/* NAV */}
      <nav className="cart-nav">
        <Link to="/" className="cart-nav__logo"><LogoComunicar height={40}/></Link>
        <Link to="/recursos" className="cart-nav__back">← Seguir comprando</Link>
      </nav>

      <div className="cart-body">

        {/* ── COLUMNA IZQUIERDA ── */}
        <div className="cart-main">

          <div className="cart-section-head">
            <h1>Tu carrito <span className="cart-count">{totalItems} {totalItems === 1 ? 'item' : 'items'}</span></h1>
            <button className="cart-vaciar" onClick={vaciarCarrito}>Vaciar carrito</button>
          </div>

          <div className="cart-aviso-digital">
            <IconDigital/>
            <span>Todos los productos son <strong>digitales</strong> — no requieren dirección de envío. Acceso inmediato tras validar el pago.</span>
          </div>

          {/* Items */}
          <div className="cart-items">
            {items.map(item => {
              const col  = colorMap[item.color] || colorMap.verde;
              const Icon = tipoIcono[item.tipo]  || IconPdf;
              return (
                <div key={item.id} className="cart-item">
                <div className="cart-item__thumb" style={{
                  background: (item.imagenes?.length > 0 || item.imagen) ? 'none' : col.bg,
                  backgroundImage: item.imagenes?.length > 0
                    ? `url(${item.imagenes[0].url})`
                    : item.imagen
                    ? `url(${item.imagen})`
                    : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: 12,
                }}>
                  {!item.imagenes?.length && !item.imagen && <span style={{color: col.text}}><Icon/></span>}
                </div>
                  
                  
                  <div className="cart-item__body">
                    <div className="cart-item__tipo">{tipoLabel[item.tipo] || 'Recurso'} · Digital</div>
                    <div className="cart-item__titulo">{item.titulo}</div>
                    {item.descripcion_larga && (
                      <div className="cart-item__desc-larga">{item.descripcion_larga}</div>
                    )}
                    <div className="cart-item__tags">


                      <span><IconDigital/> Descarga inmediata</span>
                    </div>
                  </div>
                  <div className="cart-item__precio">S/. {item.precio.toFixed(2)}</div>
                  <button className="cart-item__quitar" onClick={() => quitarItem(item.id)} title="Quitar">
                    <IconTrash/>
                  </button>
                </div>
              );
            })}
          </div>

          {/* Datos del comprador */}
          <div className="cart-form-wrap">
            <h2 className="cart-form-titulo">Datos para el pedido</h2>
            {error && <div className="cart-error">{error}</div>}
            <div className="cart-form-grid">
              <div className="cart-field">
                <label>Nombre completo <span className="cart-req">*</span></label>
                <input type="text" placeholder="Ej: Ana García" value={form.nombre} onChange={e => setF('nombre', e.target.value)}/>
              </div>
              <div className="cart-field">
                <label>Correo electrónico <span className="cart-req">*</span></label>
                <input type="email" placeholder="tu@correo.com" value={form.email} onChange={e => setF('email', e.target.value)}/>
              </div>
              <div className="cart-field cart-field--full">
                <label>WhatsApp <span style={{fontWeight:400,color:'#5a6a63'}}>— para enviarte instrucciones de acceso</span></label>
                <input type="tel" placeholder="9XX XXX XXX" value={form.telefono} onChange={e => setF('telefono', e.target.value)}/>
              </div>
            </div>
          </div>

          {/* ── CUPÓN DE DESCUENTO ── */}
          <div className="cart-cupon-wrap">
            <h2 className="cart-form-titulo">
              <IconTag/> ¿Tienes un cupón de descuento?
            </h2>

            {cuponAplicado ? (
              /* Cupón aplicado */
              <div className="cart-cupon-aplicado">
                <div className="cart-cupon-aplicado__left">
                  <span className="cart-cupon-aplicado__badge">
                    <IconCheck/> Cupón aplicado
                  </span>
                  <strong className="cart-cupon-aplicado__codigo">{cuponAplicado.codigo}</strong>
                  {cuponAplicado.descripcion && (
                    <span className="cart-cupon-aplicado__desc">{cuponAplicado.descripcion}</span>
                  )}
                </div>
                <div className="cart-cupon-aplicado__right">
                  <span className="cart-cupon-aplicado__ahorro">
                    − S/. {descuento.toFixed(2)}
                  </span>
                  <button className="cart-cupon-quitar" onClick={quitarCupon} title="Quitar cupón">
                    <IconClose/> Quitar
                  </button>
                </div>
              </div>
            ) : (
              /* Input cupón */
              <div className="cart-cupon-form">
                <div className="cart-cupon-input-wrap">
                  <input
                    type="text"
                    placeholder="Ingresa tu código de cupón"
                    value={codigoCupon}
                    onChange={e => { setCodigoCupon(e.target.value.toUpperCase()); setCuponError(''); setCuponExito(''); }}
                    onKeyDown={e => e.key === 'Enter' && validarCupon()}
                    className={'cart-cupon-input' + (cuponError?' cart-cupon-input--error':'')}
                    maxLength={30}
                  />
                  <button
                    className="cart-cupon-btn"
                    onClick={validarCupon}
                    disabled={!codigoCupon.trim() || validandoCupon}
                  >
                    {validandoCupon ? <IconSpinner/> : 'Aplicar'}
                  </button>
                </div>
                {cuponError && (
                  <p className="cart-cupon-msg cart-cupon-msg--error">⚠️ {cuponError}</p>
                )}
                {cuponExito && (
                  <p className="cart-cupon-msg cart-cupon-msg--exito">🎉 {cuponExito}</p>
                )}
              </div>
            )}
          </div>

          {/* Método de pago */}
          <div className="cart-metodos-wrap">
            <h2 className="cart-form-titulo">¿Cómo deseas pagar?</h2>
           
           
            {!estaLogueado && (
              <div className="cart-login-aviso cart-login-aviso--requerido">
              <span>🔐</span>
              <div>
                <strong>Inicia sesión para continuar</strong>
                <p>Necesitas una cuenta para completar tu compra.</p>
              </div>
              <div style={{display:'flex',gap:'.5rem',flexWrap:'wrap'}}>
                <Link to="/login?redirect=/carrito" className="cart-login-btn">Iniciar sesión</Link>
                <Link to="/registro?redirect=/carrito" className="cart-login-btn" style={{background:'transparent',border:'1.5px solid #4db88a',color:'#4db88a'}}>Crear cuenta</Link>
              </div>
            </div>
            )}


<div className="cart-metodos">
               {/*   <button className={'cart-metodo ' + (metodo==='tarjeta'?'cart-metodo--active':'')} onClick={() => setMetodo('tarjeta')}>
                <div className="cart-metodo__icon">💳</div>
                <div><strong>Pagar con tarjeta (Izipay)</strong><span>Visa, Mastercard — acceso inmediato</span></div>
                <div className="cart-metodo__radio">{metodo==='tarjeta' && <IconCheck/>}</div>
              </button>   */}
         <button
  className={'cart-metodo cart-metodo--culqi ' + (metodo === 'culqi' ? 'cart-metodo--active' : '')}
  onClick={() => setMetodo('culqi')}
>
  <div className="cart-metodo__icon">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M2 10h20" stroke="currentColor" strokeWidth="1.5"/>
      <rect x="5" y="14" width="4" height="2" rx="0.5" fill="currentColor"/>
    </svg>
  </div>

  <div className="cart-metodo__info">
    <strong>Tarjeta de crédito o débito</strong>
    <span>Tarjeta, Yape y más — acceso inmediato</span>
    <div className="cart-metodo__networks">
      <span className="cart-badge cart-badge--visa">VISA</span>
      <span className="cart-badge cart-badge--mc">
        <svg width="28" height="10" viewBox="0 0 36 14" fill="none">
          <circle cx="7" cy="7" r="7" fill="#EB001B"/>
          <circle cx="21" cy="7" r="7" fill="#F79E1B"/>
          <path d="M14 7a6.97 6.97 0 0 0 3.5-6.06A6.97 6.97 0 0 1 21 7a6.97 6.97 0 0 1-3.5 6.06A6.97 6.97 0 0 0 14 7z" fill="#FF5F00"/>
        </svg>
      </span>
      <span className="cart-badge cart-badge--yape">
        <svg width="12" height="12" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" fill="#6B21D8"/>
          <text x="12" y="16" textAnchor="middle" fontFamily="Arial" fontSize="10" fontWeight="800" fill="white">Y</text>
        </svg>
        Yape
      </span>
    </div>
  </div>

  <div className="cart-metodo__radio">
    {metodo === 'culqi' && <IconCheck/>}
  </div>
</button>

<p className="cart-metodo__seguridad">
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L4 6v6c0 5.25 3.5 10.15 8 11.35C16.5 22.15 20 17.25 20 12V6l-8-4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
  Pago seguro procesado por Culqi
</p>
             {/*  <button className={'cart-metodo ' + (metodo==='yape'?'cart-metodo--active':'')} onClick={() => setMetodo('yape')}>
                <div className="cart-metodo__icon">📱</div>
                <div><strong>Yape / Transferencia</strong><span>Envías voucher por WhatsApp — validación en 24h</span></div>
                <div className="cart-metodo__radio">{metodo==='yape' && <IconCheck/>}</div>
              </button>*/}
            </div>


            {metodo === 'yape' && (
              <div className="cart-yape-info">
                <p><strong>¿Cómo funciona?</strong></p>
                <div className="cart-yape-steps">
                  <div><span>1</span> Haz clic en "Confirmar pedido"</div>
                  <div><span>2</span> Recibirás un link a WhatsApp con los datos de pago</div>
                  <div><span>3</span> Realiza el Yape o transferencia y envía el voucher</div>
                  <div><span>4</span> Activamos tu acceso en minutos</div>
                </div>
              </div>
            )}
            {metodo === 'tarjeta' && (
              <div className="cart-tarjeta-info">
                <div className="cart-tarjeta-badges">
                  {[{icon:'🔒',label:'SSL seguro'},{icon:'✅',label:'Izipay verificado'},{icon:'🛡️',label:'Sin guardar datos'}].map(({icon,label}) => (
                    <span key={label}>{icon} {label}</span>
                  ))}
                </div>
                <p style={{fontSize:'.78rem',color:'#5a6a63',marginTop:'.5rem'}}>
                  Serás redirigido al portal seguro de Izipay. Regresarás aquí al completar el pago.
                </p>
              </div>
            )}
          </div>
        </div>

        {/* ── COLUMNA DERECHA: resumen ── */}
        <div className="cart-sidebar">
          <div className="cart-resumen">
            <h2>Resumen del pedido</h2>

            <div className="cart-resumen__items">
              {items.map(i => (
                <div key={i.id} className="cart-resumen__row">
                  <span className="cart-resumen__nombre">{i.titulo}</span>
                  <span className="cart-resumen__precio">S/. {i.precio.toFixed(2)}</span>
                </div>
              ))}
            </div>

            <div className="cart-resumen__divider"/>

            {/* Subtotal */}
            <div className="cart-resumen__row cart-resumen__row--sub">
              <span>Subtotal</span>
              <span>S/. {totalPrecio.toFixed(2)}</span>
            </div>

            {/* Descuento cupón */}
            {descuento > 0 && (
              <div className="cart-resumen__row cart-resumen__row--descuento">
                <span>
                  <IconTag/> {cuponAplicado.codigo}
                  {cuponAplicado.tipo === 'porcentaje'
                    ? ` (${cuponAplicado.valor}% OFF)`
                    : ` (S/. ${cuponAplicado.valor} OFF)`
                  }
                </span>
                <span className="cart-resumen__descuento-valor">− S/. {descuento.toFixed(2)}</span>
              </div>
            )}

            <div className="cart-resumen__divider"/>

            <div className="cart-resumen__total">
              <span>Total</span>
              <strong>S/. {totalFinal.toFixed(2)}</strong>
            </div>

            {descuento > 0 && (
              <div className="cart-resumen__ahorro">
                🎉 Ahorras S/. {descuento.toFixed(2)} con el cupón
              </div>
            )}

            <div className="cart-resumen__digital">
              <IconDigital/> Productos digitales · Sin costo de envío
            </div>

            {/* Botón pago */}
            {metodo === 'tarjeta' && (
              <button className="cart-pagar-btn cart-pagar-btn--tarjeta" onClick={pagarTarjeta} disabled={procesando}>
                {procesando ? <><IconSpinner/> Redirigiendo…</> : <>💳 Pagar con Izipay</>}
              </button>
            )}
            {metodo === 'culqi' && (
              <button className="cart-pagar-btn cart-pagar-btn--tarjeta" onClick={pagarCulqi} disabled={procesando || !culqiListo}>
                {procesando ? <><IconSpinner/> Procesando…</> : <>💳 Pagar con Culqi</>}
              </button>
            )}
            {metodo === 'yape' && (
              <button className="cart-pagar-btn cart-pagar-btn--yape" onClick={pagarYape} disabled={procesando}>
                {procesando ? <><IconSpinner/> Procesando…</> : <><IconWhatsapp/> Confirmar pedido</>}
              </button>
            )}
            {!metodo && (
              <button className="cart-pagar-btn cart-pagar-btn--disabled" disabled>
                Selecciona un método de pago
              </button>
            )}

            <div className="cart-resumen__garantias">
              <div><IconShield/> Pago 100% seguro</div>
              <div><IconCheck/> Soporte por WhatsApp</div>
            </div>

            <Link to="/politica-devoluciones" className="cart-resumen__politica">
              Ver política de devoluciones
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}